import TaskTrackingService from '../../services/TaskTrackingService';
import { createPendingCompletions } from './pendingCompletion';

// One queue for the whole app so a completion survives the drawer closing
export const pendingCompletions = createPendingCompletions({
    send: (taskId, body) => TaskTrackingService.complete(taskId, body),
    sendKeepalive: (taskId, body) => TaskTrackingService.completeKeepalive(taskId, body),
});
if (typeof window !== 'undefined') {
    window.addEventListener('pagehide', () => pendingCompletions.flushKeepalive());
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') pendingCompletions.flushKeepalive();
    });
}
